import { useParams } from 'react-router'

import { TeamEdit } from '@/modules/team/views/edit/team-edit'

export const TeamEditView = () => {
  const parameters = useParams()

  if (!parameters.id) {
    return <span>error</span> // Todo
  }

  return <TeamEdit id={parameters.id} />
}
